module.exports = __webpack_public_path__ + "img/imseo_logo.49ac8eee.svg";